import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private scripts: ScriptModel[] = [];

  public load(script: ScriptModel): Observable<ScriptModel> {
      return new Observable<ScriptModel>((observer: Observer<ScriptModel>) => {
          var existingScript = this.scripts.find(s => s.id == script.id);

          // Remove and load if loaded already - could have been from a previous attempt
          if (existingScript && existingScript.loaded) {
              const elem=document.getElementById(script.id);
              if (elem) {
                elem.parentNode.removeChild(elem);
              }
              this.loadScript(script, observer);
          }
          else {
              this.loadScript(script, observer);
          }
      });
  }

  private loadScript(script: ScriptModel, observer: Observer<ScriptModel>) {
    this.scripts = [...this.scripts, script];

    // Load the script
    let scriptElement = document.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.src = script.src;
    scriptElement.id = script.id;
    if(script.async) {
      scriptElement.async = true;
    }
    if (script.dataAttributes) {
      Object.entries(script.dataAttributes).forEach(([key, value]) => {
        scriptElement.setAttribute(`data-${key}`, value);
      });
    }
    scriptElement.onload = () => {
      script.loaded = true;
      observer.next(script);
      observer.complete();
    };

    scriptElement.onerror = (error: any) => {
      observer.error("Couldn't load script " + script.src);
    };

    document.getElementsByTagName('body')[0].appendChild(scriptElement);
  }
  public removeScript(scriptId: string): void {
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.parentNode?.removeChild(existingScript);
      delete this.scripts[scriptId]; 
      console.log(`Script with ID '${scriptId}' removed`);
    }
  }
}

export interface ScriptModel {
  id: string,
  src: string,
  loaded: boolean,
  dataAttributes?: { [key: string]: string },
  async?: boolean
}